// Equals PANEL_BG today by coincidence, not contract — don't DRY them together.
export const PUCK_BG = '#262626';
const SPINNER_COLOUR = '#fafafa';

export const PUCK_SIZE_PX = 48;
const SPINNER_SIZE_PX = 22;

const FADE_MS = 250;

const SEGMENTS = 8;
const SPIN_MS = 800;

const SPINNER_SVG = `<svg viewBox="0 0 22 22" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">${Array.from(
	{ length: SEGMENTS },
	(_, i) =>
		`<rect x="10" y="1" width="2" height="6" rx="1" fill="currentColor" opacity="${(0.25 + (0.75 * i) / (SEGMENTS - 1)).toFixed(2)}" transform="rotate(${(360 / SEGMENTS) * i} 11 11)"/>`
).join('')}</svg>`;

const SPIN_KEYFRAMES: Keyframe[] = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];
const SPIN_OPTIONS: KeyframeAnimationOptions = {
	duration: SPIN_MS,
	easing: `steps(${SEGMENTS}, end)`,
	iterations: Infinity
};

export class LoadingPuck {
	readonly element: HTMLDivElement;

	private animation: Animation | null = null;
	private fadeTimer: ReturnType<typeof setTimeout> | null = null;
	private dismissed = false;

	constructor(doc: Document) {
		const root = doc.createElement('div');
		Object.assign(root.style, {
			position: 'absolute',
			bottom: '0',
			right: '0',
			width: `${PUCK_SIZE_PX}px`,
			height: `${PUCK_SIZE_PX}px`,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			background: PUCK_BG,
			borderRadius: '50%',
			pointerEvents: 'none',
			opacity: '1',
			transition: `opacity ${FADE_MS}ms ease-out`
		} satisfies Partial<CSSStyleDeclaration>);

		const spinner = doc.createElement('div');
		Object.assign(spinner.style, {
			// Not a block: an inline svg sits on a baseline the host page's line-height can shift.
			display: 'flex',
			width: `${SPINNER_SIZE_PX}px`,
			height: `${SPINNER_SIZE_PX}px`,
			color: SPINNER_COLOUR
		} satisfies Partial<CSSStyleDeclaration>);
		spinner.innerHTML = SPINNER_SVG;
		root.appendChild(spinner);

		this.element = root;
		// Can't use a <style> tag: it breaks with strict `style-src` CSPs.
		this.animation = spinner.animate(SPIN_KEYFRAMES, SPIN_OPTIONS);
	}

	dismiss(): void {
		if (this.dismissed) return;
		this.dismissed = true;
		this.element.style.opacity = '0';
		this.fadeTimer = setTimeout(() => this.destroy(), FADE_MS);
	}

	destroy(): void {
		if (this.fadeTimer) {
			clearTimeout(this.fadeTimer);
			this.fadeTimer = null;
		}
		this.animation?.cancel();
		this.animation = null;
		this.element.remove();
	}
}
